import {fetchDelete, fetchPatch, fetchPost, generateEndpoint} from "../../../utils/request";

export const renameCategory = async({ token, id, name }) => {
  const url = `${generateEndpoint('renameCategory')}`
  return fetchPatch(url, token, { id, name })
}

export const moveCategory = async({ token, id, level, parentId }) => {
  const url = `${generateEndpoint('moveCategory')}`
  return fetchPatch(url, token, { id, level, parentId })
}

export const changeCoverImage = async({ token, id, coverImageUrl }) => {
  const url = `${generateEndpoint('changeCoverImage')}`
  return fetchPatch(url, token, { id, coverImageUrl })
}

export const createCategory = async({ token, name, parentId, level }) => {
  const url = `${generateEndpoint('createCategory')}`
  return fetchPost(url, token, { name, parentId, level })
}

export const deleteCategory = async({ token, id }) => {
  const url = `${generateEndpoint('deleteCategory')}`
  return fetchDelete(url, token, { id })
}


